import Loadable from '../../components/loadable';

const KioskAlertsReport = Loadable({
  loader: () => import('../../pages/reports/kiosk_alerts_report/kiosk_alerts_report'),
});

angular.module('gym').value('KioskAlertsReport', KioskAlertsReport);

const KioskAlertsReportFiltersModal = Loadable({
  loader: () => import('../../pages/reports/kiosk_alerts_report/kiosk_alerts_report_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('KioskAlertsReportFiltersModal', KioskAlertsReportFiltersModal);
